"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscription = exports.relation = exports.presence = exports.feedExtended = exports.default = exports.basicSubcription = exports.account = void 0;
var _normalizr = require("normalizr");
var _schemas = require("../resources/activities/schemas");
var _schemas2 = require("../resources/feeds/schemas");
var _schemas3 = require("../resources/feedItems/schemas");
var _schemas4 = require("../resources/rooms/schemas");
var _schemas5 = require("../resources/users/schemas");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var optionWithReplaceStrategy = {
  processStrategy: entity => Object.keys(entity).reduce((acc, curr) => {
    acc[curr.replace(/^_/, '')] = entity[curr];
    return acc;
  }, {})
};
var account = exports.account = new _normalizr.schema.Entity('callAccounts', {
  user: _schemas5.user
}, _objectSpread({}, optionWithReplaceStrategy));
var basicSubcription = exports.basicSubcription = new _normalizr.schema.Entity('subscriptions', {
  feed: _schemas2.feeds
});
var feedExtended = exports.feedExtended = new _normalizr.schema.Entity('feeds', {
  user: _schemas5.user
}, optionWithReplaceStrategy);
var presence = exports.presence = new _normalizr.schema.Entity('presences');

// TODO: a supprimer apres avoir virer les relations du front
var relation = exports.relation = new _normalizr.schema.Entity('relations', {
  initiator: _schemas5.user,
  target: _schemas5.user
});
var subscription = exports.subscription = new _normalizr.schema.Entity('subscriptions', {
  target: _schemas5.user,
  initiator: _schemas5.user,
  feed: _schemas2.feeds
}, optionWithReplaceStrategy);
var _default = exports.default = {
  users: _schemas5.user,
  basicSubcriptions: basicSubcription,
  subscriptions: subscription,
  rooms: _schemas4.room,
  relations: relation,
  presences: presence,
  feedItems: _schemas3.feedItems,
  feeds: _schemas2.feeds,
  feedExtendeds: feedExtended,
  accounts: account,
  anchors: _schemas2.anchors,
  activities: _schemas.activities,
  feedMembers: _schemas2.feedMembers,
  invitations: _schemas2.invitations
};